import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { graphql, compose, withApollo } from 'react-apollo'
import { deepOmit } from './../../libs/utils'

import get from 'lodash/get'
import clone from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import gql from 'graphql-tag'

import moment from 'moment'
import Loader from "../UI/Loader";
import {SelectInput, Checkbox} from '../UI'

import queriesTP from './../../graphql/TripPlanner'
import { NotificationManager } from 'react-notifications'

import {
  UPDATE_ITINERARY_DAY,
  GET_CUSTOMIZED_PLANS_LIST,
  GET_FAV_LIST
} from './../../graphql/MyTrips'


import PropTypes from 'prop-types'

import classNames from 'classnames'


class ExternalDayForm extends Component {
  static propTypes = {
    onSave: PropTypes.func,
    t: PropTypes.func,
    event: PropTypes.object,
    currentDay: PropTypes.object,
    updateFav: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      days: [],
      selectedPlan: null,
      selectedDay: null,
      showLoader: false,
      overrideOption: false
    }
  }

  getSelectedPlan = async (planId) => {
    let queryResult = await this.props.client
    .query({
      query: loadSelectedPlan,
      variables: {
        id: planId
      }
    })
    return queryResult.data.CustomizedPlan
}


  async loadSelectedDay() {
      const sourceDay = this.state.selectedDay
      const currentDay = this.props.currentDay

      const diff =
        moment(currentDay.dayOfTrip).diff(moment(sourceDay.dayOfTrip), 'days')

      // Clone the events
      let events = clone(sourceDay.contentEvents)

      events.forEach(event => {
        event.startDate = moment(event.startDate).add(diff, 'days').toISOString()
        event.endDate = moment(event.endDate).add(diff, 'days').toISOString()
      })

      let currentEvents
      if (!this.state.overrideOption) {
        // Add events from original day
        currentEvents = clone(currentDay.contentEvents)
        events.push(...currentEvents)
      }
      
      events.forEach(event => {
        if (!isEmpty(event.defaultPhoto)) {
          event.defaultPhotoId = event.defaultPhoto.id
        }

        if (Array.isArray(event.docs) && event.docs.length) {
          event.docsIds = event.docs.map(doc => doc.id)
        }

        if (Array.isArray(event.photos) && event.photos.length) {
          event.photosIds = event.photos.map(photo => photo.id)
        }

        delete event.defaultPhoto

        event.docs = []
        event.photos = []
      })

      events = deepOmit(events, ['id', '__typename'])

      try {
            // Link all notes to days
            // console.log("Day upload Copy: assign notes")
            if (sourceDay.notes && sourceDay.notes.length > 0) {
              await Promise.all(sourceDay.notes.map(note => {
                return this.props.linkIterneraryDayAndNote({
                  variables: {
                    itineraryDayId: currentDay.id,
                    noteId: note.id
                  }
                })
              }))            
            }
            // Create all events in each day
            // console.log("Day upload Copy: copy events")
            await this.props.updateItineraryDay({
              variables: {
                id: currentDay.id,
                title: sourceDay.title,
                contentEvents: events
              }
            })

            await this.props.onSave()
      }
      catch(err) {
        console.log("Error on day copy " + err)
      }
  }

  onSubmit() {
    if (this.state.selectedDay) {
      // Need to copy the existing day and "plant" it in the current day
      this.loadSelectedDay()
    }
  }

  onDayChange(day) {
    let selectedDay = this.state.selectedPlan.tripDetails.itineraryDays.find(p => {
      return p.id === day
    })
    this.setState(
      {selectedDay: selectedDay}
    )
  }

  async onDayChangeFav(day) {

    // console.log(day)

    let dayval = day.split(',')
    // console.log('dayval is ', dayval)

    let dayres = await this.onPlanChange(dayval[1])
    let selectedDay =await this.state.selectedPlan.tripDetails.TripItinerarydays.find(p => {
      return p.itineraryday.id === dayval[0]
    })
    this.setState(
      {selectedDay: selectedDay}
    )
  }


  async onPlanChange(plan) {

    // console.log('here is the plan', plan)
    this.setState({showLoader: true})
    let selectedPlan = await this.getSelectedPlan(plan)

    // console.log('here is selected plan',selectedPlan)

    const daysOptions = this.getDaysOptions(selectedPlan)
    this.setState(
      {days: daysOptions,
        selectedPlan: selectedPlan,
        showLoader: false
      }
    )
  }

  getDaysOptions = (selectedPlan) => {
    const options = [];
    selectedPlan.tripDetails.TripItinerarydays.map(day => {
      options.push({
        label: day.itineraryday.title,
        value: day.itineraryday.id,
        date: day.itineraryday.dayoftrip
      })
    })
    options.sort(function(a,b) {return (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0);} ); 
    return options
  }

  toggleOverrideOption = () => {
    this.setState({ overrideOption: !this.state.overrideOption})
  }

  getPlanOptions = () => {
    const options = [];
    if (!this.props.allCustomizedPlansQuery.loading) {
        this.props.allCustomizedPlansQuery.customizedplan.map(plan => {
            moment(plan.startDate).toISOString()
            options.push({
            label: plan.tripDetails.title + ' (' + 
                moment(plan.startDate).format('MMM D') + '-' + moment(plan.endDate).format('MMM D') + ')',
            value: plan.id
            });
        })
    }
    return options;
  }

  getFavOptions = () => {
    try {
      setTimeout(async () => {
        console.log(await this.props.allCustomizedPlans.refetch())
      }, 0)
    } catch (err) {
      // NotificationManager.error(err.message, 'Error', 5000)
    }


    const options = [];
    if (!this.props.allCustomizedPlans.loading) {
        this.props.allCustomizedPlans.customizedplan.map(plan => {
          if(plan.tripDetails.TripItinerarydays.length){
            plan.tripDetails.TripItinerarydays.map(res =>{
              moment(res.itineraryday.dayoftrip).toISOString()
              options.push({
              label: res.itineraryday.title + ' (' + 
                  moment(res.itineraryday.dayoftrip).format('MMM D')  + ')'
                  
                 ,
              value: res.itineraryday.id+','+plan.id
              });
            })
          }
        })
    }
    return options;
  }

   onRemoveFav =async () =>{
    try {
      await this.props.updateItineraryDayFavorite({
        variables: {
          id: this.state.selectedDay.id,
          isFavorite: false
        }
      })
      NotificationManager.success('ItineraryDay Removed From Favorite List', 'Success', 5000)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }

    if(this.props.currentDay.id == this.state.selectedDay.id) {
      this.props.updateFav(false)
    }
  }


  render() {
    const { t } = this.props

    // console.log('here is render External', this.props)

    if (this.props.allCustomizedPlansQuery.loading) {
      return <Loader showLoader={true} />
    }


    const containerClassNames = classNames({
      container: false,
      event: true,
      'container-fluid': true
    })

    return (
      <div className={containerClassNames}>
        <div className="row">
          <div
            className={classNames({
              'col-md-6 col-md-offset-3': false,
              'col-md-12': true
            })}
          >
            <h1>{t('load_day_from_plan')}</h1>

            <hr />

            <div className="form-horizontal event__form-container">
              <div className="form-group">
                <label htmlFor="type" className="event__form-label col-md-3 control-label">
                  {t('select_plan')}
                </label>

                <div className="col-md-9">
                  <SelectInput
                    id="plan"
                    className="form-control event__form-input"
                    options={this.getPlanOptions()}
                    onChange={(...args) =>  {
                      this.onPlanChange(args[1])
                    }}
                    simpleValue
                    placeholder={t('select_from_plans')}
                    clearable={false}
                    isGroup={false}/>
                </div>
              </div>
              <div className="form-group">
                  <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                    {t('select_plan_day')}
                  </label>
                  <div className="col-md-9">
                    <SelectInput
                      id="planDays"
                      className="form-control event__form-input"
                      options={this.state.days}
                      simpleValue
                      placeholder={t('select_from_plan_days')}
                      clearable={false}
                      isGroup={false}
                      onChange={(...args) =>  {
                        this.onDayChange(args[1])
                      }}
                      />
                  </div>
              </div>

            
              <div className="form-group">
                  <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                    {t('select_fav_day')}
                  </label>
                  <div className="col-md-9">
                  <SelectInput
                    id="planFavDay"
                    className="form-control event__form-input"
                    options={this.getFavOptions()}
                    onChange={(...args) =>  {
                      console.log(args)
                      this.onDayChangeFav(args[1])
                    }}
                    simpleValue
                    placeholder={t('select_from_fav')}
                    clearable={false}
                    isGroup={false}/>
                  </div>
                  
              </div>
              <div className="form-group">
                <label htmlFor="Remove" className="event__form-label col-md-3 control-label">
                  &nbsp;
                </label>
                <div className="col-md-9">
                  <button className="btn btn-sm btn-primary btnRm" onClick={() => this.onRemoveFav()}>
                  {t('removeFav')}</button>
                </div>
              </div>        



              <form>
              <div className="form-group">
                <label htmlFor="overrideEvents" className="event__form-label col-md-3 control-label">
                  &nbsp;
                </label>
                <div className="col-md-9">
                  <Checkbox 
                    className="form-control event__form-input"
                    handleChange={this.toggleOverrideOption} id="overrideEvents">
                  {t('override_events')}
                  </Checkbox>
                </div>
              </div>
              </form>
            </div>
            <button className="btn event__submit-btn" onClick={() => this.onSubmit()}>
              {t('load_day')}
            </button>
          </div>
        </div>
        <Loader showLoader={this.state.showLoader} />
      </div>      
    )
  }
}

const loadSelectedPlan = gql`${queriesTP.GET_CUSTOMIZED_PLAN}`
// const updateItineraryFav = gql`${queriesTP.UPDATE_ITINERARY_DAY_FAVORITE}`

export default compose(
  translate('trip_planner'),
  graphql(GET_CUSTOMIZED_PLANS_LIST, {
    name: 'allCustomizedPlansQuery',
    options: props => ({
        variables: {
        tripGuruId: get(props, 'user.id', '')
        }
    })
}),

graphql(GET_FAV_LIST, {
  name: 'allCustomizedPlans',
  options: props => ({
      variables: {
      tripGuruId: get(props, 'user.id', '')
      }
  })
}),

graphql(queriesTP.LINK_ITINERARY_DAY_AND_NOTE, {
  name: 'linkIterneraryDayAndNote'
}),
graphql(queriesTP.UPDATE_ITINERARY_DAY_FAVORITE, {
  name: 'updateItineraryDayFavorite'
}),

graphql(UPDATE_ITINERARY_DAY, {
  name: 'updateItineraryDay'
}),
withApollo
)(ExternalDayForm)




// WEBPACK FOOTER //
// src/components/TripPlanner/ExternalDayForm.js